import React, { useState, useEffect } from "react";
import { ArrowPathIcon } from "@heroicons/react/24/solid";
import { toast } from "react-toastify";
import { updateCommentById } from "../../../redux/reducer/commentReducer";
import { useDispatch } from "react-redux";

const UpdateTestimonialForm = ({ onClose, testimonialData }) => {
  const [name, setName] = useState("");
  const [commentAr, setCommentAr] = useState("");
  const [commentEn, setCommentEn] = useState("");
  const [rating, setRating] = useState("");
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  // console.log(testimonialData);

  const dispatch = useDispatch();

  useEffect(() => {
    if (testimonialData) {
      setName(testimonialData?.name || "");
      setCommentAr(testimonialData?.comment_AR || "");
      setCommentEn(testimonialData?.comment_EN || "");
      setRating(testimonialData?.rate || "");
      setImagePreview(testimonialData?.image || "");
    }
  }, [testimonialData]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async () => {
    const updatedData = new FormData();
    updatedData.append("name", name);
    updatedData.append("comment_AR", commentAr);
    updatedData.append("comment_EN", commentEn);
    updatedData.append("rate", rating);
    if (image) updatedData.append("image", image);

    try {
      setIsLoading(true);
      await dispatch(
        updateCommentById({ id: testimonialData._id, data: updatedData })
      ).unwrap();

      // console.log("Updated testimonial:", Object.fromEntries(updatedData));
      toast.success("Testimonial updated successfully!");
      onClose();
    } catch (error) {
      toast.error("Failed to update testimonial");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white w-[90%] sm:w-[50%] p-6 rounded-xl shadow-xl ">
        <div className="max-h-[90vh] overflow-y-scroll space-y-4 p-2">
          <h2 className="mb-4 text-xl font-bold text-gray-900">
            Update Testimonial
          </h2>

          {/* Name */}
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Name
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-400 focus:outline-none"
            />
          </div>

          {/* Comment Arabic */}
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Comment (Arabic)
            </label>
            <textarea
              value={commentAr}
              onChange={(e) => setCommentAr(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg resize-none focus:ring-2 focus:ring-yellow-400 focus:outline-none bg-gray-50"
              rows={3}
            />
          </div>

          {/* Comment English */}
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Comment (English)
            </label>
            <textarea
              value={commentEn}
              onChange={(e) => setCommentEn(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg resize-none focus:ring-2 focus:ring-yellow-400 focus:outline-none bg-gray-50"
              rows={3}
            />
          </div>

          {/* Country + Rating */}
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {/* Rating */}
            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Rating (1–5)
              </label>
              <select
                value={rating}
                onChange={(e) => setRating(e.target.value)}
                className="w-full px-3 py-1 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-400 focus:outline-none bg-gray-50"
              >
                <option value="">Select rating</option>
                {[1, 2, 3, 4, 5].map((num) => (
                  <option key={num} value={num}>
                    {num} Star{num > 1 ? "s" : ""}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Image Upload */}
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Image
            </label>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              className="block w-full text-sm text-gray-700 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-yellow-400 file:text-black hover:file:bg-yellow-500"
            />
            {imagePreview && (
              <img
                src={imagePreview}
                alt="Preview"
                className="object-cover mt-3 rounded-lg shadow-md w-28 h-28"
              />
            )}
          </div>

          {/* Buttons */}
          <div className="flex justify-end gap-3 pt-4">
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300"
            >
              Cancel
            </button>

            {isLoading ? (
              <ArrowPathIcon className="w-10 h-10 p-2 text-white bg-yellow-500 rounded-full animate-spin" />
            ) : (
              <button
                onClick={handleSubmit}
                className="px-5 py-2 text-sm font-semibold text-black rounded-lg bg-custom-yellow hover:bg-yellow-500"
              >
                Update
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateTestimonialForm;
